import $ from 'jquery';

export default function(){
    $(".section-image_blockicon[data-image-handle]").on('click', function(){
        var handle = $(this).attr('data-image-handle');
        var $parent = $(this).closest('#section-product');
        $parent.find('[data-image]').attr('data--hidden', 'true');
        $parent.find('[data-image="'+handle+'"]').removeAttr('data--hidden');
        $(this).closest('.section-product_main').find('[data-variant-url]').attr('href', $(this).attr('data-url'));

        var originalPrice = $(this).attr('data-variant-price');
        var comparePrice = $(this).attr('data-variant-compare-at-price');

        $(this).closest('.section-product_main').find('.origin_price').text(originalPrice);
        if (typeof comparePrice != 'undefined' && comparePrice.length > 0) {
            $(this).closest('.section-product_main').find('.compare_price').text(comparePrice).show();
        } else {
            $(this).closest('.section-product_main').find('.compare_price').hide().css('display','none');
        }
    });


    var url = location.href;

    if(url.indexOf('/blogs/') > 0) {
        if(url.indexOf('?') > 0) {
            var handle = (url.split('?'))[1];

            var $target = $('.blog_header_item[data-type="'+handle+'"]');
            $target.click();

            $("html, body").animate({
                scrollTop: $target.offset().top - 100
            }, 500);
        }
    }

}